// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"1e95605b","453":"5e0bcedd","500":"ccb4010a","692":"413c94a5","871":"88862044","892":"c9756afc"}[chunkId] + ".chunk.js";
};